export const isDashboardScreen = () => {
  return (
    document.location.href.includes('/dashboard') ||
    document.location.href.includes('/settings')
  );
};

export const isJSON = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const isStaging = () => process.env.VITE_STAGE !== 'production';
